enum HelpTrackingKeys {
  trainingWebinars = "trainingWebinars",
  launching = "launchingPerkbox",
  customisation = "customisation",
  peopleManagement = "peopleManagement",
  billingPayments = "billingPayments"
}

export default HelpTrackingKeys
